import { createContext, useContext } from "react";
export const NoctuaContext = createContext({
  partidos: [],
  clientParty: null,
  refreshPartidos: () => {},
  setClient: () => {},
  selectedState: 8,
  setSelectedState: () => {},
  allStates: [],
  // Subaccount scope filter (null for super_admin, populated for subaccount context)
  scopeFilter: null, // { scope_type, entidad_clave, municipio_clave, distrito_clave, municipio_nombre, entidad_nombre }
});
export const useNoctua = () => useContext(NoctuaContext);
